import { render, staticRenderFns } from "./ops_desk.vue?vue&type=template&id=2711255b&scoped=true&"
import script from "./ops_desk.vue?vue&type=script&lang=js&"
export * from "./ops_desk.vue?vue&type=script&lang=js&"
import style0 from "./ops_desk.vue?vue&type=style&index=0&id=2711255b&scoped=true&lang=css&"
import style1 from "./ops_desk.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2711255b",
  null
  
)

export default component.exports